import { useEffect, useState } from "react";
import api from "../api/api";

function AdminNewspapers() {
  const [papers,  setPapers]  = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/newspapers")
      .then(res => setPapers(Array.isArray(res.data) ? res.data : []))
      .catch(() => setPapers([]))
      .finally(() => setLoading(false));
  }, []);

  const deletePaper = (id) => {
    if (!window.confirm("Delete this newspaper?")) return;
    api.delete(`/admin/newspaper/${id}`)
      .then(() => setPapers(prev => prev.filter(p => p.newspaperId !== id)));
  };

  if (loading) return <p className="text-muted fs-13">Loading newspapers…</p>;

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">All Newspapers</div>
        <span className="badge badge-muted">{papers.length} total</span>
      </div>

      {papers.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">📰</div>
          <div className="empty-title">No newspapers yet</div>
          <div className="empty-sub">Add your first newspaper above</div>
        </div>
      ) : (
        <div className="paper-grid" style={{ padding: 22 }}>
          {papers.map(p => (
            <div className="paper-card" key={p.newspaperId}>
              <div className="paper-card-top">
                <div>
                  <div className="paper-card-name">{p.name}</div>
                  <div className="paper-card-lang">{p.language || "General"}</div>
                </div>
                <span style={{ fontSize: 26 }}>📰</span>
              </div>
              <div className="paper-card-body">
                <div className="price-row">
                  <span className="price-lbl">Daily Rate</span>
                  <span className="price-val">₹{p.dailyPrice}/day</span>
                </div>
                <div className="price-row">
                  <span className="price-lbl">Monthly Package</span>
                  <span className="price-val">₹{p.monthlyPrice}/mo</span>
                </div>
              </div>
              <div className="paper-card-foot">
                <button className="btn btn-danger btn-sm"
                  onClick={() => deletePaper(p.newspaperId)}>
                  🗑 Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AdminNewspapers;
